module.exports = __webpack_public_path__ + "static/Segment-9a2af92868f69fdeb184b6d8b4626a6f.png";